import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCarouselItem } from './model/image-carousel-item.model';

@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit {
  @Input() carouselItems: Array<ImageCarouselItem>;
  @Input() delay: number = 2000;
  @Input() automatic: boolean = true;
  @Input() needButtons: boolean = true;
  @Input() needIndicators: boolean = true;
  @Input() fullImage: boolean = true;

  picArray: Array<any> = [];
  selectedImgIndex: number = 0;

  constructor(private sanitization: DomSanitizer) {}

  ngOnInit() {
    for (var i = 0; i < this.carouselItems.length; i++) {
      let url = this.sanitization.bypassSecurityTrustStyle(
        'url("./././assets/imgs' + this.carouselItems[i].img + '")'
      );
      this.picArray.push(url);
    }

    setInterval(() => {
      if (this.automatic) {
        this.next();
      }
    }, this.delay);
  }

  jumpTo(index: number) {
    this.selectedImgIndex = index;
  }

  next() {
    this.selectedImgIndex++;
    if (this.selectedImgIndex > this.carouselItems.length - 1) {
      this.selectedImgIndex = 0;
    }
  }
  prev() {
    this.selectedImgIndex--;
    if (this.selectedImgIndex < 0) {
      this.selectedImgIndex = this.carouselItems.length - 1;
    }
  }
}
